import React, { ReactElement, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import debounce from 'lodash/debounce'

import { TextField } from '@flowwai-frontend/design-system'
import { InfoCircle, SearchSmIcon } from '@flowwai-frontend/design-system/icons'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { removeInvisibleCharacters } from '@flowwai-frontend/bps-officer-web/common/ui'

import {
   containerClassName,
   escContainerClassName,
   rightElementContainerClassName
} from './styles'

interface Props {
   onChangeSearchQuery: (query: string) => void
}

const GlobalSearchHeader = (props: Props) => {
   const { onChangeSearchQuery } = props

   const t = useCustomT('globalSearch:searchModal')
   const { theme } = useAppTheme()

   const {
      escTextColor,
      escBgColor,
      escBorderColor,
      headerBorderColor
   } = theme.globalSearch.searchModal

   const [searchQuery, setSearchQuery] = useState('')

   const debounceSearchQueryChange = useRef(
      debounce((value: string): void => onChangeSearchQuery(value), 300)
   )
   const onChangeText = (value: string): void => {
      const visibleCharacters = removeInvisibleCharacters(value)
      //NOTE: added above filter to remove invisible characters

      setSearchQuery(visibleCharacters)
      debounceSearchQueryChange.current(visibleCharacters)
   }

   const renderLeftElement = (): ReactElement => (
      <div className={'mr-8px'}>
         <SearchSmIcon
            width={20}
            height={20}
            stroke={theme.globalSearch.searchIconColor}
         />
      </div>
   )

   const renderRightElement = (): ReactElement => (
      <div className={rightElementContainerClassName}>
         <div className='mr-2' title={t('searchInputTooltipDescription')}>
            <InfoCircle />
         </div>
         <div
            className={`${escContainerClassName} ${escBgColor} ${escBorderColor}`}
         >
            <p className={`${escTextColor} text-sm-regular`}>{t('escText')}</p>
         </div>
      </div>
   )

   return (
      <div className={`${containerClassName} ${headerBorderColor}`}>
         <TextField
            value={searchQuery}
            onChange={onChangeText}
            placeholder={t('globalSearchInputPlaceholder')}
            size={'Small'}
            leftElement={renderLeftElement}
            rightElement={renderRightElement}
            focusRingVariant={'None'}
            inputContainerClassName={'!border-none !shadow-none'}
            autoFocus={true}
         />
      </div>
   )
}

export default observer(GlobalSearchHeader)
